var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#9AA7B0",
    fillOpacity: 0.8,
    points: "7 1 3 5 7 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AA7B0",
    fillOpacity: 0.8,
    d: "M10.9997,15 L2.9997,15 L2.9997,6 L7.9997,6 L7.9997,1 L12.9997,1 C12.9914069,2.84997911 12.9838819,4.51666712 12.9771251,6.00006403 C10.7785117,6.01237564 9,7.79849099 9,10 C9,10.231552 9.04249042,10.5667624 9.12747127,11.0056312 C9.7627201,11.0056312 10.3867963,11.0056312 10.9997,11.0056312 L10.9997,15 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40B6E0",
    d: "M12.25,16 L13.75,16 L13.75,14.5 L12.25,14.5 L12.25,16 Z M13,7 C11.3425,7 10,8.3425 10,10 L11.5,10 C11.5,9.175 12.175,8.5 13,8.5 C13.825,8.5 14.5,9.175 14.5,10 C14.5,11.5 12.25,11.3125 12.25,13.75 L13.75,13.75 C13.75,12.0625 16,11.875 16,10 C16,8.3425 14.6575,7 13,7 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUnknown);
export default __webpack_public_path__ + "static/media/file-unknown.6d8d28cc4669de75a3a8e6691d7ef0b6.svg";
export { ForwardRef as ReactComponent };